// extracted by mini-css-extract-plugin
export var compactFilters = "_k8-4";
export var detailImage = "_k8-1";
export var dropdownContainer = "_k8-2";
export var imageContainer = "_k8-0";
export var selectedCard = "_k8-3";